module.exports = __webpack_public_path__ + "static/img/3D动画制作.c5b52f31.png";